import {
  Grid,
  TextField,
  FormControl
} from '@mui/material';
import { forwardRef } from 'react';
import { DatePicker, PickersDay } from '@mui/lab';

interface DatePickerProps {
  label?: string;
  value: Date | null,
  disable?: boolean,
  minDate?: Date | null,
  maxDate?: Date | null,
  onChange: (e: any) => void,
  fullWidth: boolean | null,
  mt?: number | null,
  views?: any | null,
  inputFormat?: string | null
}

const SingleDatePicker = forwardRef((props: DatePickerProps, _ref) => {
  
  const getDate = (date) => {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
  }

  return (
    <FormControl className='date-filter' fullWidth={props?.fullWidth}>
      <Grid sx={{ mt: props.mt ? props?.mt : 1 }} position='relative'>
        <DatePicker
          views={props?.views && props?.views}
          inputFormat={props?.inputFormat ? props?.inputFormat : "yyyy-MM-dd"}
          disabled={props?.disable}
          label={props?.label}
          InputProps={{
            className: 'date-picker',
          }}
          minDate={props?.minDate && getDate(props?.minDate)}
          maxDate={props?.maxDate && getDate(props?.maxDate)}
          renderInput={(params) => (
            <TextField {...params} id="date" 
              inputProps={{...params.inputProps, readOnly: true}}
            />
          )}
          renderDay={(day, _value, DayComponentProps) => {
            return (
              <PickersDay {...DayComponentProps}/>
            )
          }}
          value={props?.value}
          onChange={(newValue) => {
            if (newValue) {
              props?.onChange(newValue);
            }
          }}
        />
      </Grid>
    </FormControl>
    
  );
});

export default SingleDatePicker;
